import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export interface I18nResources {
  en: Record<string, any>;
  vi: Record<string, any>;
}

export interface I18nInitOptions {
  resources: I18nResources;
  defaultLanguage?: string;
  fallbackLanguage?: string;
  debug?: boolean;
}

/**
 * Initialize i18n with provided translations
 * @param options - Configuration options for i18n
 */
export function initI18n(options: I18nInitOptions) {
  const {
    resources,
    defaultLanguage = "vi",
    fallbackLanguage = "vi",
    debug = false,
  } = options;

  const i18nResources = {
    en: {
      translation: resources.en,
    },
    vi: {
      translation: resources.vi,
    },
  };

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: i18nResources,
      lng: defaultLanguage,
      fallbackLng: fallbackLanguage,
      debug,

      interpolation: {
        escapeValue: false, // React already escapes values
      },

      detection: {
        order: ["localStorage", "navigator", "htmlTag"],
        caches: ["localStorage"],
      },
    });

  return i18n;
}

export default i18n;
